import type { FC, ReactElement } from 'react'

import { FormattedMessage } from 'react-intl'

import { EditTranslations } from './EditTranslations'
import { useMessage } from './hooks'

type TranslationProps = Record<string, string | ReactElement> & { id: string; className?: string }

export const Translation: FC<TranslationProps> = ({ id, className, ...variables }) => {
  const croppedId = useMessage(id)

  return (
    <span className={className}>
      <FormattedMessage id={croppedId} values={{ ...variables }} />
      <EditTranslations croppedId={croppedId} />
    </span>
  )
}
